import axios from 'axios'

import config from '../../config'

const createCondition = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/Conditions`
  return axios.post(url, data)
}

export default createCondition
